import type { ITween, ITweenResponse, ITweenElemParams, ITweenFromToParams, ITweenTransformParams } from './definitions'

import getTranslateDirection from './getTranslateDirection'
import calculateTranslate    from './calculateTranslate'
import getScaleDifference    from './getScaleDifference'
import transform             from './transform'
import easings               from './easings'
import fromTo                from './fromTo'
import anims                 from './anims'
import run                   from './run'

const tween: ITween = {
  easings,
  anims,

  // Promise-alapú tween
  add: (params: ITweenElemParams): Promise<HTMLElement> => {
    return new Promise((resolve) => {
      const nextParams: ITweenTransformParams = {
        ...params,
        onEnd: resolve
      }

      tween.transform(nextParams)
    })
  },

  // Azért más, mint az add, mert le lehet lőni a res.stop -al
  transform: (params: ITweenTransformParams): ITweenResponse => {
    const ease = params.easing ?? easings.linear
    const tf   = transform(params)
    const res  = run(ease, params.duration, tf.progress, tf.ready, tf.cancel, params.onUpdate)

    return res
  },

  calculateTranslate,

  getScaleDifference,

  getTranslateDirection,

  fromTo: (params: ITweenFromToParams): ITweenResponse => {
    const transformParams = fromTo(params)

    return tween.transform(transformParams)
  }
}

// eslint-disable-next-line custom/export-default-name
export default tween
